import React, { useEffect } from "react";
import { MdError } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import '../../../../styles/superAdmin/modal.css';


const ErrorPopup = ({ message, message2, onClose }) => {
  

  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!message) return null;

  return (
    <div className="popup-wrapper">
      <div className="popup-content error">
        <div className="popup-inner">
          <div className="popup-icon">
            <MdError className="icon" size={18} />
          </div>
          <div className="popup-text">
            <p className="main">{message}</p>
          </div>
            <button className="close-btn" onClick={onClose}>
          <IoMdClose className="icon" size={15}/>
        </button>
        </div>
      
      </div>
    </div>
  );
};

export default ErrorPopup;
